import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { FeedbackMessage } from '@gemini/ui';
import { useMapContext } from '@/hooks/useMapContext/useMapContext';
import { useMapTileError } from '@/hooks/useMapTileError/useMapTileError';
import { useMobileViewDetect } from '@/hooks/useMobileViewDetect/useMobileViewDetect';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
export const MapTileError = () => {
    const { map } = useMapContext();
    const { isMobileView } = useMobileViewDetect();
    const { hasError, canBeDisplayedOnMobile, setHasError } = useMapTileError(map);
    const { t } = useShellTranslation();
    const shouldDisplayError = hasError && (isMobileView ? canBeDisplayedOnMobile : true);
    return (_jsx(_Fragment, { children: shouldDisplayError && (_jsx(Box, { position: "relative", left: "50%", transform: "translateX(-50%)", zIndex: isMobileView ? 'zIndex.4' : 'zIndex.3', top: "spacing.16", padding: "spacing.16", children: _jsx(FeedbackMessage, { title: '', variant: "warning", onClose: () => setHasError(false), children: t('map.tile_error_toast') }) })) }));
};
